/**
 * 自定义页面最简结构
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, compontent_tool } from '@/tool'
import { templateConfig, reduxTemplateCofig } from './config'
import {component_tool} from "../../../../tool";

const { WizContainer, modelUtils,WizReduxTemplate } = framework_tool
const { WizBrowserExport, WizModal } = component_tool;

class TaskInfo extends WizContainer {
  // 组件名 必传
  componentName = 'TaskInfo';

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {}
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
   let columnDefs = [
    {
      headerName: '',
      width: 30,
      field: 'rowIndex',
      hidden: true,
      suppressMovable: true,
      cellStyle: {
        textAlign: 'center',
        padding: '5px 0',
        color: '#595959',
        backgroundColor: '#f0f0f0',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500',
        boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
      },
    },
    {
        headerName: '任务名称',
        field: 'name',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
     {
       headerName: '业务类型',
       field: 'bizType',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '重要程度',
       field: 'importance',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '开始时间',
       field: 'startDate',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '结束时间',
       field: 'endDate',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '状态',
       field: 'state',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '任务来源',
       field: 'source',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '是否消息通知',
       field: 'needNotice',
       width: 25,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
     {
       headerName: '是否启用',
       field: 'status',
       width: 20,
       cellStyle: {
         textAlign: 'center',
       },
       style: {
         alignment: { vertical: 'bottom', horizontal: 'left' },
       },
     },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        switch (e.bizType) {
          case 0: e['bizType'] = '课程';break;
          case 1: e['bizType'] = '考试';break;
          case 26: e['bizType'] = '直播';break;
          case 15: e['bizType'] = '报名';break;
          case 45: e['bizType'] = '班级环节';break;
          case 20: e['bizType'] = '内容通知';break;
          case 59: e['bizType'] = '练习';break;
        }
        e['importance'] == 0 ? e['importance'] = '重要' : e['importance'] = '一般'
        switch (e.state) {
          case 0: e['state'] = '未开始';break;
          case 1: e['state'] = '执行中';break;
          case 2: e['state'] = '已结束';break;
          case 3: e['state'] = '已取消';break;
        }
        e['source'] == 0 ? e['source'] = '新培训平台' : e['source'] = '第三方系统'
        e['needNotice'] == 0 ? e['needNotice'] = '否': e['needNotice'] = '是'
        e['status'] == 0 ? e['status'] = '否': e['status'] = '是'
      })
      WizBrowserExport({
        title: '任务信息',
        sheetName: '任务信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '任务信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  // 渲染函数
  _render() {
    let _templateConfig = templateConfig({
      _btnFun: (e) => {
        if (e && e.rows && e.rows.length && e.rows.length === 1) {
          let record = {}
          e.rows.forEach(d => {
            record = d
          })
          this.jumpPage('push','/taskInfo/taskNotice',record)
        } else {
          WizModal.confirm({
            title: '请选择一条数据',
            onOk: () => {},
            onCancel() {}
          })
        }
      }
    })
    let _reduxTemplateCofig = reduxTemplateCofig({
        templateConfig: _templateConfig,
        apiDataFormat: {
          add: this._handleCMD,
          update: this._handleCMD,
          export: this._handleFile,
        },
      })
      return <WizReduxTemplate {..._reduxTemplateCofig} />
    }

}

// 数据源
const mapStateToProps = (state, ownProps) => {
    return {}
}

// connect把数据源和视图连接起来
export default connect(mapStateToProps)(TaskInfo)
